export default __webpack_public_path__ + "media/images/images_v2/filtre-373208a45bb94e494abe89a68bf5e9a4.png";